import React, { ReactNode } from 'react'
import Icon from '../Icon'
import bubbleTextIcon from '../../assets/icons/bubble-text.svg'
import bubbleTextIconLight from '../../assets/icons/bubble-text-white.svg'
import './TextLine.css';
import { IIconProps } from '../Icon/Icon';
import DynamicContainer from '../../foundational/Layout/DynamicContainer';

interface ITLIconprops extends IIconProps {
    topAlign?: boolean;
}

export interface ITextLineProps {
    className?: string;
    textClass?: string;
    authorClass?: string;
    icon?: ITLIconprops;
    subHeading?: string;
    subHeadingTag?: string;
    subHeadingClass?: string;
    children: ReactNode;
    variant?: 'author' | 'bubble-icon' |'bubble-icon-light' | 'custom';
    tag?: string;
    isDarkMode?: boolean;
}

const TextLine = ({
    className = '',
    textClass = '',
    subHeadingClass='',
    icon,
    subHeading= '',
    subHeadingTag='p',
    children,
    tag = 'p',
    variant = 'custom',
    authorClass = ' ',
    isDarkMode= false,
    ...rest
}: ITextLineProps) => {
    const addLeftBorder = variant === 'author' ? `${isDarkMode ? 'TextLine__leftBorder--darkMode' : 'TextLine__leftBorder'} ${authorClass}` : ''
    const formattedClassName = variant !== 'custom' ? 'pl-4' : ''

    return (
        <div className={`TextLine ${className || ''} flex ${!icon?.topAlign ? 'items-center' :'' }`} {...rest}>
            {icon?.src && <Icon {...icon}/>}
            {!icon?.src && variant === 'bubble-icon' && 
                <Icon src={bubbleTextIcon} customSize={32} alt={`${icon?.alt || 'Bubble Icon'}`} {...icon}/>}
            {!icon?.src && variant === 'bubble-icon-light' && 
                <Icon src={bubbleTextIconLight} customSize={32} alt={`${icon?.alt || 'Bubble Icon White'}`} {...icon}/>}
            {subHeading !== '' ? 
                <div className={`flex flex-col justify-center ${addLeftBorder}`}>
                    <DynamicContainer 
                        displayTag tag={tag} 
                        className={`${textClass || ''} ${formattedClassName} ${isDarkMode ? 'text-white': ''} mt-1`}>
                            {children}
                    </DynamicContainer>
                    <DynamicContainer 
                        displayTag tag={subHeadingTag} 
                        className={`${subHeadingClass || ''} ${isDarkMode ? 'text-white': ''} ${formattedClassName} mb-2`}>
                            {subHeading}
                    </DynamicContainer>
                </div> :
                <DynamicContainer 
                    displayTag tag={tag} 
                    className={`${textClass || ''} ${isDarkMode ? 'text-white': ''} ${formattedClassName} ${addLeftBorder} mb-0`}>
                        {children}
                </DynamicContainer>
        }
        </div>
    )
}

export default TextLine;